<template>
    <div id="callbackTask">
        <!-- 导航栏 -->
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
            <div class="headerText">回调任务</div>
            <div class="rule" @click="inCallbackTaskByLaws">细则</div>
        </div>
        <!-- 回调任务面板 -->
        <div class="callbackTaskPanel">
            <div class="panels panelsMargin">
                <div class="title">回调任务</div>

                <div class="taskItem" v-for="(item,index) in callbackTask" :key="index" @click="inCallbackTaskOngoing(item.id)">
                    <div class="taskTops">
                        <div class="taskItemLeft">
                            <div class="icons"><img :src="item.icon" alt=""></div>
                            <div class="centers">
                                <div class="taskTile">{{item.name}}</div>
                                <div class="others">
                                    当前剩余<span v-if="item.remaining_number > 1000">1000+</span><span v-else>{{item.remaining_number}}</span>份
                                </div>
                            </div>
                        </div>
                        <div class="taskItemRight"><span>赚</span>{{item.tuser_price}}<span>元</span></div>
                    </div>
                    <div class="line"></div>
                </div>

                <div class="taskItem" v-for="(item,index) in wanpuTaskList" :key="index" @click="goWanpuTaskDetail(item)">
                    <div class="taskTops">
                        <div class="taskItemLeft">
                            <div class="icons"><img :src="item.app_icon" alt=""></div>
                            <div class="centers">
                                <div v-if="item.searchWord != ''" class="taskTile">{{item.searchWord}}</div>
                                <div v-else class="taskTile">{{item.app_name}}</div>
                                <!-- <div class="others">
                                    当前剩余<span v-if="item.remaining_number > 1000">1000+</span><span v-else>{{item.remaining_number}}</span>份
                                </div> -->
                            </div>
                        </div>
                        <div class="taskItemRight"><span>赚</span>{{ (item.points/100).toFixed(2) }}<span>元</span></div>
                    </div>
                    <div class="line"></div>
                </div>

                <div class="taskInfo" v-if="callbackTask.length <= 0 && wanpuTaskList.length <= 0">
                    {{currentTaskToast}}
                </div>
            </div>

            <div class="boxPadding">
                <div class="heraldTask heraldTaskMargin">
                    <div class="title">任务预告</div>
                    <div class="taskItem" v-for="(ite,ind) in heraldTask" :key="ind">
                        <div class="taskTops">
                            <div class="taskItemLeft">
                                <div class="icons"><img :src="item.icon" alt=""></div>
                                <div class="centers">
                                    <div class="taskTile">{{ite.name}}</div>
                                    <span class="heraldOthers">
                                        剩余<span v-if="ite.remaining_number > 1000">1000+</span><span v-else>{{ite.remaining_number}}</span>份
                                    </span>
                                </div>
                            </div>
                            <div class="taskItemRight"><span>赚</span>{{ite.tuser_price}}<span>元</span></div>
                        </div>
                        <div class="line"></div>
                    </div>
                    <div class="taskInfo" v-if="heraldTask.length <= 0">
                        {{forecastTaskToast}}
                    </div>
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
    import clientApi from '../assets/js/clientApi.js';

    export default {
        components:{

        },
        data() {
            return {
                callbackTask:[],
                heraldTask:[],
                currentTaskToast: '正在加载回调任务中...',
                forecastTaskToast: '正在加载任务预告中...',
                wanpuTaskList: [],
            }
        },
        created() {
            this.init();
        },
        methods: {
            // 初始化 回调任务列表
            init(){
                this.$loading(true);
                let promise_one = new Promise((resolve, reject) => {
                    let datas = {}
                    this.$http.GETS('callback_task/tasklist',datas,(res)=>{
                        resolve(res);
                    });
                })
                // 获取万普任务
                let promise_two = new Promise((resolve, reject) => {
                    clientApi.getv2deviceinfo().then((data) => {
                        let datas = {
                            dv : data.data.dv, 
                            osv : data.data.osv,
                            wifi : data.data.wifi,
                            devicename : data.data.devicename,
                            jb : data.data.jb,
                            user : data.data.user,
                            openudid : data.data.openudid,
                            ifa : data.data.ifa
                        };
                        this.$http.GETS('out_union/waiPuTaskList', datas, (res) => {
                            resolve(res);
                        });
                    });
                });
                
                Promise.all([promise_one, promise_two]).then((res) => {
                    this.$loading(false);

                    this.callbackTask = res[0].data.now_list
                    this.heraldTask = res[0].data.future_list

                    this.currentTaskToast = '目前暂无任务，建议稍后刷新看看'
                    this.forecastTaskToast = '目前暂无任务预告'

                    // 万普任务
                    this.wanpuTaskList = res[1].data;
                })
            },
            // 返回
            returnPage:function(){
                this.$router.go(-1);
            },
            // 进入万普任务
            goWanpuTaskDetail(item) {
                location.href = item.click_url;
            },
            // 进入 回调任务细则
            inCallbackTaskByLaws:function(){
                this.$router.push('/callbackTask/callbackTaskByLaws');
            },
            // 进入 回调任务进行中
            inCallbackTaskOngoing:function(ids){
                // console.log(ids)
                // this.$router.push({name:'callbackTaskOngoing',query: {ids:ids}});
                this.$loading(true);
                let datas = {
                    task_id:ids
                }
                this.$http.POSTS('callback_task/startTask',datas,(res)=>{
                    // console.log(res);
                    this.$loading(false);
                    this.$router.push({name:'callbackTaskOngoing',query: {ids:ids}});
                });
            }
        },
    }
</script>

<style lang="less" scoped>
    #callbackTask{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #returns{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
            .rule{
                font-size:15px;
                color:rgba(255,255,255,1);
                position: absolute;
                right: 25px;
            }
        }
        // 回调任务面板
        .callbackTaskPanel{
            width:375px;
            height:50px;
            padding-top: 8px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .panelsMargin{
                margin: 0 15px;
            }
            .boxPadding{
                padding: 21px 15px 15px;
            }
            .panels,.heraldTask{
                width:345px;
                background:rgba(255,255,255,1);
                border-radius:5px;
                border:1px solid rgba(222,222,222,.5);
                padding: 6px 0 8px;
                .title{
                    font-size:17px;
                    font-weight:600;
                    color:rgba(51,51,51,1);
                    margin: 0 0 21px 9px;
                }
                .taskItem{
                    width: 290px;
                    margin: 0 25px;
                    .taskTops{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .taskItemLeft{
                            display: flex;
                            align-items: center;
                            .icons{
                                width:44px;
                                height:44px;
                            }
                            img{
                                width:44px;
                                height:44px;
                                border-radius: 12px;
                            }
                            .centers{
                                height: 44px;
                                padding: 0 15px;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-around;
                                .taskTile{
                                    font-size:14px;
                                    font-weight:500;
                                    color:rgba(85,85,85,1);
                                    line-height:20px;
                                }
                                .others{
                                    font-size:11px;
                                    font-weight:500;
                                    color:rgba(196,194,194,1);
                                    line-height:16px;
                                }
                                .heraldOthers{
                                    border-radius:12px;
                                    border:1px solid rgba(229,229,229,1);
                                    font-size: 11px;
                                    color: #C4C2C2;
                                    text-align: center;
                                    padding: 3px 7px;
                                }
                            }
                        }
                        .taskItemRight{
                            font-size:20px;
                            font-family:'Qds';
                            font-weight: bold;
                            color:rgba(230,9,26,1);
                            line-height:24px;
                            white-space: nowrap;
                            span{
                                font-size: 16px;
                                font-weight: normal;
                            }
                        }
                    }
                    .line{
                        width:233px;
                        height:1px;
                        background: #ECECEC;
                        margin: 6px 0px 9px 60px;
                    }
                }
                .taskInfo{
                    margin: 25px 0;
                    font-size:14px;
                    color:rgba(153,153,153,.7);
                    line-height:11px;
                    text-align: center;
                }
            }
        }

    }
</style>